// Storage may throw SecurityError (restricted in-app browsers, embedded contexts).
const fallback = new Map();
export const safeLocalStorage = {
  getItem(key) {
    try { return window.localStorage?.getItem(key) ?? fallback.get(key) ?? null; }
    catch { return fallback.get(key) ?? null; }
  },
  setItem(key, value) {
    fallback.set(key, String(value));
    try { window.localStorage?.setItem(key, String(value)); } catch { /* blocked */ }
  },
  removeItem(key) {
    fallback.delete(key);
    try { window.localStorage?.removeItem(key); } catch { /* blocked */ }
  },
};

let fallbackAnonymousId = null;
export function getSafeAnonymousId() {
  try {
    const stored = safeLocalStorage.getItem('hv_anonymousId');
    if (stored) return stored;
    const id = fallbackAnonymousId || crypto.randomUUID();
    fallbackAnonymousId = id;
    safeLocalStorage.setItem('hv_anonymousId', id);
    return id;
  } catch {
    fallbackAnonymousId ||= String(Date.now()) + Math.random().toString(36);
    return fallbackAnonymousId;
  }
}
